/* eslint-disable no-restricted-syntax */
import React, { useContext } from 'react';
import { QuickAppointmentContext } from '../Context';
import { getVehicleType } from '../VehicleConstants';
import AddVehicleForm from '../components/VehicleForm/AddVehicleForm';
import { restructureVehicleData } from '../vehicleHelper';

const VehicleForm = ({ vehicleList }) => {
  const {
    customerType,
    contactData,
    existingData,
    handleNext,
    vehicleData,
    setVehicleData,
    setSavedData,
    setNote,
    getSearchData,
  } = useContext(QuickAppointmentContext);

  const onCreating = () => {
    setNote({ text: 'Creating customer vehicle...', type: 'info' });
  };

  const onError = () => {
    setNote({
      text: 'Could not create vehicle. Please try again.',
      type: 'error',
    });
  };

  const onSuccess = (json) => {
    if (customerType === 'new') {
      setSavedData((prev) => ({
        ...prev,
        customer_vehicle_id: json?.id,
      }));
    } else if (customerType === 'existing') {
      const customerId = contactData.id;
      getSearchData(customerId);
    }
    setNote({ text: 'Customer vehicle created!', type: 'success' });
    setVehicleData({
      vehicle_id: json.id,
      inputMethodType: json.input_method_type,
      [json.input_method_type]: restructureVehicleData(json),
      photo_filenames: json.photo_filenames,
      type: getVehicleType(json),
      oil_capacities: json.oil_capacities,
    });
    handleNext();
  };

  const onSelectVehicle = (vehicleId) => {
    const { vehicles } = existingData;
    const existingVehicle = vehicles.find((item) => item.id === vehicleId);

    const inputMethodType = existingVehicle.input_method_type;
    setVehicleData({
      vehicle_id: vehicleId,
      photo_filenames: existingVehicle.photo_filenames,
      inputMethodType,
      [inputMethodType]: restructureVehicleData(existingVehicle),
      type: getVehicleType(existingVehicle),
      oil_capacities: existingVehicle.oil_capacities,
    });
    handleNext();
  };

  const onSaveSelectedVehicle = () => {
    handleNext();
  };

  const skip = () => {
    setVehicleData(null);
    handleNext();
  };

  return (
    <AddVehicleForm
      customerType={customerType}
      vehicleData={vehicleData}
      vehicleList={vehicleList}
      customerId={contactData?.id}
      onCreating={onCreating}
      onError={onError}
      onSuccess={onSuccess}
      onSelectVehicle={onSelectVehicle}
      onSaveSelectedVehicle={onSaveSelectedVehicle}
      onSkip={skip}
    />
  );
};

export default VehicleForm;
